<template lang="pug">
  .teach-guide-container
    .teach-guide-box
      swiper.teach-guide-swiper(:options="swiperOption" ref="teachSwiper")
        swiper-slide(v-for="(item, index) in guideSteps" :key="item.id")
          img.teach-guide-img(:src="item.imgUrl" alt="")
      .teach-guide-frame
      .swiper-btn.prev-btn(
        v-if="currentStep > 0"
        @click="handleSwiperBtnClick('prev')"
      )
      .swiper-btn.next-btn(
        v-if="currentStep < guideSteps.length - 1"
        @click="handleSwiperBtnClick('next')"
      )
    //- 指示器
    .custom-pagination
      .pagination-dot(
        v-for="(item, index) in guideSteps"
        :key="item.id"
        :class="{ active: currentStep === index }"
        @click="handleDotClick(index)"
      )
    NextButton(
      text="下一步"
      @btnClick="handleNextClick"
      @skipClick="handleSkipClick"
    )
</template>

<script>
import SPM from '../common/spm';
import NextButton from './next-button';

export default {
  name: 'VideoGuide',
  components: {
    NextButton,
  },
  props: {
    // 商品信息
    goodsInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      // 当前步骤索引
      currentStep: 0,
      // 引导步骤数据
      guideSteps: this.goodsInfo.floatingLayerUrls || [],
      // swiper配置
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false, // 禁止手势滑动
        autoplay: true,
        loop: false,
        pagination: false, // 使用自定义指示器
        navigation: false, // 禁用导航按钮
        on: {
          slideChange: () => {
            this.currentStep = this.$refs.teachSwiper.$swiper.activeIndex;
          },
        },
      },
    };
  },
  mounted() {
    // 教学引导模块曝光埋点
    SPM.moduleExpose({
      moduleId: 'newcus_fourth',
      contentId: 'newcus_fourth',
      businessInfo: {},
    });
  },
  methods: {
    // 下一步点击
    handleNextClick() {
      // 教学引导模块点击埋点（下一步按钮点击）
      SPM.clickButton({
        buttonName: 'newcus_fourth',
        businessInfo: {},
      });

      if (this.currentStep === this.guideSteps.length - 1) {
        // 最后一步，触发完成事件
        this.$emit('nextClick');
        return;
      }
      // 切换到下一个步骤
      this.goToNextStep();
    },
    // 跳过点击
    handleSkipClick() {
      this.$emit('skipClick');
    },
    // 切换到下一个步骤
    goToNextStep() {
      if (this.$refs.teachSwiper && this.$refs.teachSwiper.$swiper) {
        this.$refs.teachSwiper.$swiper.slideNext();
        this.currentStep = this.$refs.teachSwiper.$swiper.activeIndex;
      }
    },
    // 跳转到指定步骤
    handleDotClick(index) {
      if (this.$refs.teachSwiper && this.$refs.teachSwiper.$swiper) {
        this.$refs.teachSwiper.$swiper.slideTo(index);
        this.currentStep = index;
      }
    },
    // 切换到上一个或下一个步骤
    handleSwiperBtnClick(type) {
      if (type === 'prev') {
        this.$refs.teachSwiper.$swiper.slidePrev();
      }
      if (type === 'next') {
        this.$refs.teachSwiper.$swiper.slideNext();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.teach-guide-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #000;
  animation: ease-in-out 0.5s collect;

  @keyframes collect {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .teach-guide-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.7rem;
    height: 5.58rem;
  }

  .teach-guide-frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    background-image: url('https://m.hellobike.com/resource/gallery/833/J-WN2AL0_frame.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .teach-guide-swiper {
    width: 2.47rem;
    height: 5.35rem;
    position: relative;
    border-radius: 0.3rem;
    background-color: #2b2b2b;

    .teach-guide-img {
      width: 100%;
      height: 100%;
      vertical-align: bottom;
    }
  }

  .swiper-btn {
    position: absolute;
    width: 0.27rem;
    height: 0.27rem;
    border-image-repeat: no-repeat;
    background-size: 100% 100%;

    &.prev-btn {
      left: -0.35rem;
      background-image: url('https://m.hellobike.com/file-1755659916437-693578962.png');
    }

    &.next-btn {
      right: -0.35rem;
      background-image: url('https://m.hellobike.com/file-1755659916437-517517653.png');
    }
  }

  .custom-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.14rem 0 0.26rem;

    .pagination-dot {
      margin-right: 0.08rem;
      width: 0.08rem;
      height: 0.08rem;
      border-radius: 50%;
      background-color: #6d6d6d;
      transition: transform 0.3s ease;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background-color: #fff;
        transform: scale(1.2);
      }
    }
  }
}
</style>
